var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconMessageLoadingComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'mag-seller';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-MessageLoading").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 17", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3C4.96243 3 2.5 5.46243 2.5 8.5C2.5 11.5376 4.96243 14 8 14C11.0376 14 13.5 11.5376 13.5 8.5C13.5 8.08579 13.8358 7.75 14.25 7.75C14.6642 7.75 15 8.08579 15 8.5C15 12.366 11.866 15.5 8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C8.41421 1.5 8.75 1.83579 8.75 2.25C8.75 2.66421 8.41421 3 8 3Z" }));
}
var IconMessageLoading = React.forwardRef(IconMessageLoadingComponent);
export default IconMessageLoading;
